/**
 * Svg template paths
 * https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/design-templates/01-general-purpose-template.svg
 */

/**
 * Agency logo links from cdn
 * https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/agency-logos/raywhite-agency-logo.png
 * https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/agency-logos/raywhite-original-logo.png
 * https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/agency-logos/harcourts-3-color-logo.png
 * https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/agency-logos/heritage-logo-3-color-logo.png
 * https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/agency-logos/remax-logo.png
 * https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/agency-logos/top-estates-3-color-logo.png
 * https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/agency-logos/greenview-2-color-logo.png
 */

/**
 * Sample agent profile images links from cdn
 * General agent images
 *
 * Agent image
 * https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/profile-images/compressed-demo-male-agent-profile-image.jpg
 *
 * Co-agent image
 * https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/profile-images/compressed-demo-female-agent-profile-image.jpg
 *
 * https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/profile-images/slwilson.jpg
 * https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/profile-images/sarah-wilson-profile-photo.jpg
 * https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/profile-images/harry-potter-profile-image.jpg
 * https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/profile-images/rose-potter-profile-image.jpg
 * https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/profile-images/john-weak-profile-image.jpg
 * https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/profile-images/eric-pillai-profile-image.jpg
 * https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/profile-images/anna-belle-profile-image.jpg
 * https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/profile-images/150X200-image.avif
 */

/**
 * General property image
 * https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/property-images/house-mage-compressed-06.jpg
 *
 * Sample property images links from cdn
 * https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/property-images/property-image-1.jpg
 * https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/property-images/property-image-2.webp
 * https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/property-images/marvin-meyer-bfOQSDwEFg4-unsplash.jpg
 * https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/property-images/dillon-kydd-2keCPb73aQY-unsplash.jpg
 * https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/property-images/1000X750-image.webp
 */

/**
 * Sample addresses
 * Au:24 Harbour View Drive, Bondi NSW 2026
 * Nz:18 Kowhai Street, Remuera, Auckland 1050
 *
 *
 * Sample mobile numbers
 * AU: 0412 345 678 and 0435 987 654
 * NZ: 021 123 4567 and 027 987 6543
 */

class PropertyStagesDesignData {
  static getAvailableDate = () => {
    const date = new Date();
    date.setMonth(date.getMonth() + 1);

    const day = date.getDate();

    const month = date
      .toLocaleString("en-AU", { month: "short" })
      .toUpperCase();

    const year = date.getFullYear();

    return `AVAILABLE - ${day} ${month} ${year}`;
  };

  static getNextWeekOpenHomeDate = () => {
    const nextWeek = new Date();
    nextWeek.setDate(nextWeek.getDate() + 7);

    const day = nextWeek.getDate();
    const month = nextWeek.toLocaleString("en-US", { month: "long" });

    const suffix =
      day % 10 === 1 && day !== 11
        ? "st"
        : day % 10 === 2 && day !== 12
          ? "nd"
          : day % 10 === 3 && day !== 13
            ? "rd"
            : "th";

    return `on ${day}${suffix} ${month}, 11-11:30 AM`;
  };

  static getNextWeekAuctionDate = () => {
    const nextWeek = new Date();
    nextWeek.setDate(nextWeek.getDate() + 7);

    const day = nextWeek.getDate();
    const month = nextWeek.toLocaleString("en-US", { month: "long" });

    const suffix =
      day % 10 === 1 && day !== 11
        ? "st"
        : day % 10 === 2 && day !== 12
          ? "nd"
          : day % 10 === 3 && day !== 13
            ? "rd"
            : "th";

    return `on ${day}${suffix} ${month}, 11-11:30 AM`;
  };

  static commonFontsData = {
    title: {
      font_300: {
        postscript_name: "ArchivoExpanded-Light",
        loaded: false,
        error: false,
      },
      font_300_italic: {
        postscript_name: "ArchivoExpanded-LightItalic",
        loaded: false,
        error: false,
      },
      font_400: {
        postscript_name: "ArchivoExpanded-Regular",
        loaded: false,
        error: false,
      },
      font_400_italic: {
        postscript_name: "ArchivoExpanded-Italic",
        loaded: false,
        error: false,
      },
      font_500: {
        postscript_name: "ArchivoExpanded-Medium",
        loaded: false,
        error: false,
      },
      font_500_italic: {
        postscript_name: "ArchivoExpanded-MediumItalic",
        loaded: false,
        error: false,
      },
      font_600: {
        postscript_name: "ArchivoExpanded-SemiBold",
        loaded: false,
        error: false,
      },
      font_600_italic: {
        postscript_name: "ArchivoExpanded-SemiBoldItalic",
        loaded: false,
        error: false,
      },
      font_700: {
        postscript_name: "ArchivoExpanded-Bold",
        loaded: false,
        error: false,
      },
      font_700_italic: {
        postscript_name: "ArchivoExpanded-BoldItalic",
        loaded: false,
        error: false,
      },
      font_800: {
        postscript_name: "ArchivoExpanded-ExtraBold",
        loaded: false,
        error: false,
      },
      font_800_italic: {
        postscript_name: "ArchivoExpanded-ExtraBoldItalic",
        loaded: false,
        error: false,
      },
      font_900: {
        postscript_name: "ArchivoExpanded-Black",
        loaded: false,
        error: false,
      },
      font_900_italic: {
        postscript_name: "ArchivoExpanded-BlackItalic",
        loaded: false,
        error: false,
      },
    },

    subtitle: {
      font_300: {
        postscript_name: "ArchivoExpanded-Light",
        loaded: false,
        error: false,
      },
      font_300_italic: {
        postscript_name: "ArchivoExpanded-LightItalic",
        loaded: false,
        error: false,
      },
      font_400: {
        postscript_name: "ArchivoExpanded-Regular",
        loaded: false,
        error: false,
      },
      font_400_italic: {
        postscript_name: "ArchivoExpanded-Italic",
        loaded: false,
        error: false,
      },
      font_500: {
        postscript_name: "ArchivoExpanded-Medium",
        loaded: false,
        error: false,
      },
      font_500_italic: {
        postscript_name: "ArchivoExpanded-MediumItalic",
        loaded: false,
        error: false,
      },
      font_600: {
        postscript_name: "ArchivoExpanded-SemiBold",
        loaded: false,
        error: false,
      },
      font_600_italic: {
        postscript_name: "ArchivoExpanded-SemiBoldItalic",
        loaded: false,
        error: false,
      },
      font_700: {
        postscript_name: "ArchivoExpanded-Bold",
        loaded: false,
        error: false,
      },
      font_700_italic: {
        postscript_name: "ArchivoExpanded-BoldItalic",
        loaded: false,
        error: false,
      },
      font_800: {
        postscript_name: "ArchivoExpanded-ExtraBold",
        loaded: false,
        error: false,
      },
      font_800_italic: {
        postscript_name: "ArchivoExpanded-ExtraBoldItalic",
        loaded: false,
        error: false,
      },
      font_900: {
        postscript_name: "ArchivoExpanded-Black",
        loaded: false,
        error: false,
      },
      font_900_italic: {
        postscript_name: "ArchivoExpanded-BlackItalic",
        loaded: false,
        error: false,
      },
    },

    body: {
      font_300: {
        postscript_name: "ArchivoExpanded-Light",
        loaded: false,
        error: false,
      },
      font_300_italic: {
        postscript_name: "ArchivoExpanded-LightItalic",
        loaded: false,
        error: false,
      },
      font_400: {
        postscript_name: "ArchivoExpanded-Regular",
        loaded: false,
        error: false,
      },
      font_400_italic: {
        postscript_name: "ArchivoExpanded-Italic",
        loaded: false,
        error: false,
      },
      font_500: {
        postscript_name: "ArchivoExpanded-Medium",
        loaded: false,
        error: false,
      },
      font_500_italic: {
        postscript_name: "ArchivoExpanded-MediumItalic",
        loaded: false,
        error: false,
      },
      font_600: {
        postscript_name: "ArchivoExpanded-SemiBold",
        loaded: false,
        error: false,
      },
      font_600_italic: {
        postscript_name: "ArchivoExpanded-SemiBoldItalic",
        loaded: false,
        error: false,
      },
      font_700: {
        postscript_name: "ArchivoExpanded-Bold",
        loaded: false,
        error: false,
      },
      font_700_italic: {
        postscript_name: "ArchivoExpanded-BoldItalic",
        loaded: false,
        error: false,
      },
      font_800: {
        postscript_name: "ArchivoExpanded-ExtraBold",
        loaded: false,
        error: false,
      },
      font_800_italic: {
        postscript_name: "ArchivoExpanded-ExtraBoldItalic",
        loaded: false,
        error: false,
      },
      font_900: {
        postscript_name: "ArchivoExpanded-Black",
        loaded: false,
        error: false,
      },
      font_900_italic: {
        postscript_name: "ArchivoExpanded-BlackItalic",
        loaded: false,
        error: false,
      },
    },
  };

  /**
   * Sample data for the for sale post
   */
  static for_sale_listing_property_marketing_for_sale = {
    template_url: {
      url: "https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/design-templates/01-general-purpose-template.svg",
      load: false,
    },
    output_image_file_path: {
      url: "E:/Projects/priyakant-makwana/design-work-repo/priyakant-makwana-design-work/output-images/24-06-2025/image-post-7cdf23c1-b194-11f0-aa94-7b7e22fd0c48-1761391175676.jpg",
      load: false,
    },
    output_image_relative_path: {
      url: "E:/Projects/priyakant-makwana/design-work-repo/priyakant-makwana-design-work/output-images/24-06-2025/image-post-7cdf23c1-b194-11f0-aa94-7b7e22fd0c48-1761391175676.jpg",
      load: false,
    },
    output_source_file_path: {
      url: "E:/Projects/priyakant-makwana/design-work-repo/priyakant-makwana-design-work/output-image-templates/24-06-2025/updated-template-7cdf23c2-b194-11f0-aa94-7b7e22fd0c48-1761391175676.ai",
      load: false,
    },
    property_stage: "Just Listed",
    property_address: "12 Chifley Drive, Preston, Victoria, 3072",
    agency_logo: {
      url: "https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/agency-logos/raywhite-original-logo.png",
      load: true,
    },
    design_main_image: {
      url: "https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/property-images/house-mage-compressed-06.jpg",
      load: true,
    },

    design_images: [
      {
        url: "https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/property-images/marvin-meyer-bfOQSDwEFg4-unsplash.jpg",
        load: true,
        index: 0,
        image_type: "property_image",
      },
      {
        url: "https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/property-images/1000X750-image.webp",
        load: true,
        index: 1,
        image_type: "property_image",
      },
    ],

    /**
     * Property price types
     * price-range
     * price-per-week
     * price-per-month
     * contact-agent
     * offer-above-xyz-price
     * content-agent-for-sell
     * price-guide-xyz-price
     * eoi
     */
    property_price_type: "price-range",
    start_price: "$20,000",
    end_price: "$50,000",
    property_price: "$800",
    base_color_primary: { r: 255, g: 0, b: 0, hex: "#FFE512" },
    base_color_secondary: { r: 255, g: 255, b: 255, hex: "#595959" },
    text_color_primary: { r: 255, g: 255, b: 255, hex: "#595959" },
    text_color_secondary: { r: 255, g: 0, b: 0, hex: "#FFFFFF" },
    agent_name: "Ethan Cooper",
    agent_email: "new.agentemail@domain.com",
    agent_phone: "0400777888",
    agent_profile_image_path: {
      url: "https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/profile-images/compressed-demo-male-agent-profile-image.jpg",
      load: true,
    },
    // is_co_agent_available: false,
    co_agent_profile_image_path: {
      url: "https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/profile-images/compressed-demo-female-agent-profile-image.jpg",
      load: true,
    },

    /**
     * If co-agent not available
     */
    // co_agent_profile_image_path: null,

    co_agent_name: "Grace Harrison",
    co_agent_email: "new.coagentemail@domain.com",
    co_agent_phone: "0434509348",
    bathroom_count: 3,
    bedroom_count: 4,
    living_count: 2,
    parking_count: 1,
    property_area: "1020 m²",
    eoi_datetime: "26.09.2025, 06:00 PM",
    post_type: "image_post",
    design_template_id: "68fcaf8010a67d04555eb0da",
    agency_trading_name: "Greenview Real Estate",
    agency_website: "website.com.au",
    office_contact: "0434509348",
    office_email: "info@website.com.au",
    agency_address: "123 Main Street, Anytown, Australia",
    /**
     * Datetime info field
     * We can add following dates for this setup here
     * Open home date
     * Auction date
     * Property availability date for sale or rent properties
     */
    // datetime_info: null,
    datetime_info: this.getNextWeekOpenHomeDate(),
    bond_price: "$2,500",

    fonts: this.commonFontsData,

    /**
     * Possible values
     *
     * for_rent or for_sale
     */
    listing_type: "for_sale",

    /**
     * Possible values
     *
     * For sale
     * coming_soon |  just_listed  | auction | open_home | under_contract | sold
     *
     * For rent
     * coming_soon | just_listed  | open_home | deposit_taken | leased
     */
    property_stage_type: "just_listed",

    /**
     * Transaction type values
     * For sale | For rent | Sale | Rent | Lease
     * etc
     */
    transaction_type_text: "For sale",
  };

  /**
   * Sample data for the coming soon post
   */
  static coming_soon_property_marketing_for_sale = {
    template_url: {
      url: "https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/design-templates/01-general-purpose-template.svg",
      load: false,
    },
    output_image_file_path: {
      url: "E:/Projects/priyakant-makwana/design-work-repo/priyakant-makwana-design-work/output-images/24-06-2025/image-post-7cdf23c1-b194-11f0-aa94-7b7e22fd0c48-1761391175676.jpg",
      load: false,
    },
    output_image_relative_path: {
      url: "E:/Projects/priyakant-makwana/design-work-repo/priyakant-makwana-design-work/output-images/24-06-2025/image-post-7cdf23c1-b194-11f0-aa94-7b7e22fd0c48-1761391175676.jpg",
      load: false,
    },
    output_source_file_path: {
      url: "E:/Projects/priyakant-makwana/design-work-repo/priyakant-makwana-design-work/output-image-templates/24-06-2025/updated-template-7cdf23c2-b194-11f0-aa94-7b7e22fd0c48-1761391175676.ai",
      load: false,
    },
    property_stage: "Coming Soon",
    property_address: "12 Chifley Drive, Preston, Victoria, 3072",
    agency_logo: {
      url: "https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/agency-logos/raywhite-original-logo.png",
      load: true,
    },
    design_main_image: {
      url: "https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/property-images/house-mage-compressed-06.jpg",
      load: true,
    },

    design_images: [
      {
        url: "https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/property-images/marvin-meyer-bfOQSDwEFg4-unsplash.jpg",
        load: true,
        index: 0,
        image_type: "property_image",
      },
      {
        url: "https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/property-images/1000X750-image.webp",
        load: true,
        index: 1,
        image_type: "property_image",
      },
    ],

    /**
     * Property price types
     * price-range
     * price-per-week
     * price-per-month
     * contact-agent
     * offer-above-xyz-price
     * content-agent-for-sell
     * price-guide-xyz-price
     * eoi
     */
    property_price_type: "price-range",
    start_price: "$20,000",
    end_price: "$50,000",
    property_price: "$800",
    base_color_primary: { r: 255, g: 0, b: 0, hex: "#FFE512" },
    base_color_secondary: { r: 255, g: 255, b: 255, hex: "#595959" },
    text_color_primary: { r: 255, g: 255, b: 255, hex: "#595959" },
    text_color_secondary: { r: 255, g: 0, b: 0, hex: "#FFFFFF" },
    agent_name: "Ethan Cooper",
    agent_email: "new.agentemail@domain.com",
    agent_phone: "0400777888",
    agent_profile_image_path: {
      url: "https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/profile-images/compressed-demo-male-agent-profile-image.jpg",
      load: true,
    },
    // is_co_agent_available: false,
    co_agent_profile_image_path: {
      url: "https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/profile-images/compressed-demo-female-agent-profile-image.jpg",
      load: true,
    },

    /**
     * If co-agent not available
     */
    // co_agent_profile_image_path: null,

    co_agent_name: "Grace Harrison",
    co_agent_email: "new.coagentemail@domain.com",
    co_agent_phone: "0434509348",
    bathroom_count: 3,
    bedroom_count: 4,
    living_count: 2,
    parking_count: 1,
    property_area: "1020 m²",
    eoi_datetime: "26.09.2025, 06:00 PM",
    post_type: "image_post",
    design_template_id: "68fcaf8010a67d04555eb0da",
    agency_trading_name: "Greenview Real Estate",
    agency_website: "website.com.au",
    office_contact: "0434509348",
    office_email: "info@website.com.au",
    agency_address: "123 Main Street, Anytown, Australia",
    /**
     * Datetime info field
     * We can add following dates for this setup here
     * Open home date
     * Auction date
     * Property availability date for sale or rent properties
     */
    // datetime_info: null,
    datetime_info: this.getNextWeekOpenHomeDate(),
    bond_price: "$2,500",

    fonts: this.commonFontsData,

    /**
     * Possible values
     *
     * for_rent or for_sale
     */
    listing_type: "for_sale",

    /**
     * Possible values
     *
     * For sale
     * coming_soon |  just_listed | auction | open_home | under_contract
     *
     * For rent
     * coming_soon | just_listed | open_home | deposit_taken
     */
    property_stage_type: "coming_soon",

    /**
     * Transaction type values
     * For sale | For rent | Sale | Rent | Lease
     * etc
     */
    transaction_type_text: "For sale",
  };

  /**
   * Sample data for the open home for rent post
   */
  static open_home_property_marketing_for_sale = {
    template_url: {
      url: "https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/design-templates/01-general-purpose-template.svg",
      load: false,
    },
    output_image_file_path: {
      url: "E:/Projects/priyakant-makwana/design-work-repo/priyakant-makwana-design-work/output-images/24-06-2025/image-post-7cdf23c1-b194-11f0-aa94-7b7e22fd0c48-1761391175676.jpg",
      load: false,
    },
    output_image_relative_path: {
      url: "E:/Projects/priyakant-makwana/design-work-repo/priyakant-makwana-design-work/output-images/24-06-2025/image-post-7cdf23c1-b194-11f0-aa94-7b7e22fd0c48-1761391175676.jpg",
      load: false,
    },
    output_source_file_path: {
      url: "E:/Projects/priyakant-makwana/design-work-repo/priyakant-makwana-design-work/output-image-templates/24-06-2025/updated-template-7cdf23c2-b194-11f0-aa94-7b7e22fd0c48-1761391175676.ai",
      load: false,
    },
    property_stage: "Open Home",
    property_address: "12 Chifley Drive, Preston, Victoria, 3072",
    agency_logo: {
      url: "https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/agency-logos/raywhite-original-logo.png",
      load: true,
    },
    design_main_image: {
      url: "https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/property-images/house-mage-compressed-06.jpg",
      load: true,
    },

    design_images: [
      {
        url: "https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/property-images/marvin-meyer-bfOQSDwEFg4-unsplash.jpg",
        load: true,
        index: 0,
        image_type: "property_image",
      },
      {
        url: "https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/property-images/1000X750-image.webp",
        load: true,
        index: 1,
        image_type: "property_image",
      },
    ],

    /**
     * Property price types
     * price-range
     * price-per-week
     * price-per-month
     * contact-agent
     * offer-above-xyz-price
     * content-agent-for-sell
     * price-guide-xyz-price
     * eoi
     */
    property_price_type: "price-range",
    start_price: "$20,000",
    end_price: "$50,000",
    property_price: "$800",
    base_color_primary: { r: 255, g: 0, b: 0, hex: "#FFE512" },
    base_color_secondary: { r: 255, g: 255, b: 255, hex: "#595959" },
    text_color_primary: { r: 255, g: 255, b: 255, hex: "#595959" },
    text_color_secondary: { r: 255, g: 0, b: 0, hex: "#FFFFFF" },
    agent_name: "Ethan Cooper",
    agent_email: "new.agentemail@domain.com",
    agent_phone: "0400777888",
    agent_profile_image_path: {
      url: "https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/profile-images/compressed-demo-male-agent-profile-image.jpg",
      load: true,
    },
    // is_co_agent_available: false,
    co_agent_profile_image_path: {
      url: "https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/profile-images/compressed-demo-female-agent-profile-image.jpg",
      load: true,
    },

    /**
     * If co-agent not available
     */
    // co_agent_profile_image_path: null,

    co_agent_name: "Grace Harrison",
    co_agent_email: "new.coagentemail@domain.com",
    co_agent_phone: "0434509348",
    bathroom_count: 3,
    bedroom_count: 4,
    living_count: 2,
    parking_count: 1,
    property_area: "1020 m²",
    eoi_datetime: "26.09.2025, 06:00 PM",
    post_type: "image_post",
    design_template_id: "68fcaf8010a67d04555eb0da",
    agency_trading_name: "Greenview Real Estate",
    agency_website: "website.com.au",
    office_contact: "0434509348",
    office_email: "info@website.com.au",
    agency_address: "123 Main Street, Anytown, Australia",
    /**
     * Datetime info field
     * We can add following dates for this setup here
     * Open home date
     * Auction date
     * Property availability date for sale or rent properties
     */
    // datetime_info: null,
    datetime_info: this.getNextWeekOpenHomeDate(),
    bond_price: "$2,500",

    fonts: this.commonFontsData,

    /**
     * Possible values
     *
     * for_rent or for_sale
     */
    listing_type: "for_sale",

    /**
     * Possible values
     *
     * For sale
     * coming_soon |  just_listed | auction | open_home | under_contract
     *
     * For rent
     * coming_soon | just_listed | open_home | deposit_taken
     */
    property_stage_type: "open_home",

    /**
     * Transaction type values
     * For sale | For rent | Sale | Rent | Lease
     * etc
     */
    transaction_type_text: "for sale",
  };

  /**
   * Sample data for the under offer post
   */
  static under_offer_property_marketing_for_sale = {
    template_url: {
      url: "https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/design-templates/01-general-purpose-template.svg",
      load: false,
    },
    output_image_file_path: {
      url: "E:/Projects/priyakant-makwana/design-work-repo/priyakant-makwana-design-work/output-images/24-06-2025/image-post-7cdf23c1-b194-11f0-aa94-7b7e22fd0c48-1761391175676.jpg",
      load: false,
    },
    output_image_relative_path: {
      url: "E:/Projects/priyakant-makwana/design-work-repo/priyakant-makwana-design-work/output-images/24-06-2025/image-post-7cdf23c1-b194-11f0-aa94-7b7e22fd0c48-1761391175676.jpg",
      load: false,
    },
    output_source_file_path: {
      url: "E:/Projects/priyakant-makwana/design-work-repo/priyakant-makwana-design-work/output-image-templates/24-06-2025/updated-template-7cdf23c2-b194-11f0-aa94-7b7e22fd0c48-1761391175676.ai",
      load: false,
    },
    property_stage: "Under Offer",
    property_address: "12 Chifley Drive, Preston, Victoria, 3072",
    agency_logo: {
      url: "https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/agency-logos/raywhite-original-logo.png",
      load: true,
    },
    design_main_image: {
      url: "https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/property-images/house-mage-compressed-06.jpg",
      load: true,
    },

    design_images: [
      {
        url: "https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/property-images/marvin-meyer-bfOQSDwEFg4-unsplash.jpg",
        load: true,
        index: 0,
        image_type: "property_image",
      },
      {
        url: "https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/property-images/1000X750-image.webp",
        load: true,
        index: 1,
        image_type: "property_image",
      },
    ],

    /**
     * Property price types
     * price-range
     * price-per-week
     * price-per-month
     * contact-agent
     * offer-above-xyz-price
     * content-agent-for-sell
     * price-guide-xyz-price
     * eoi
     */
    property_price_type: "price-range",
    start_price: "$20,000",
    end_price: "$50,000",
    property_price: "$800",
    base_color_primary: { r: 255, g: 0, b: 0, hex: "#FFE512" },
    base_color_secondary: { r: 255, g: 255, b: 255, hex: "#595959" },
    text_color_primary: { r: 255, g: 255, b: 255, hex: "#595959" },
    text_color_secondary: { r: 255, g: 0, b: 0, hex: "#FFFFFF" },
    agent_name: "Ethan Cooper",
    agent_email: "new.agentemail@domain.com",
    agent_phone: "0400777888",
    agent_profile_image_path: {
      url: "https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/profile-images/compressed-demo-male-agent-profile-image.jpg",
      load: true,
    },
    // is_co_agent_available: false,
    co_agent_profile_image_path: {
      url: "https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/profile-images/compressed-demo-female-agent-profile-image.jpg",
      load: true,
    },

    /**
     * If co-agent not available
     */
    // co_agent_profile_image_path: null,

    co_agent_name: "Grace Harrison",
    co_agent_email: "new.coagentemail@domain.com",
    co_agent_phone: "0434509348",
    bathroom_count: 3,
    bedroom_count: 4,
    living_count: 2,
    parking_count: 1,
    property_area: "1020 m²",
    eoi_datetime: "26.09.2025, 06:00 PM",
    post_type: "image_post",
    design_template_id: "68fcaf8010a67d04555eb0da",
    agency_trading_name: "Greenview Real Estate",
    agency_website: "website.com.au",
    office_contact: "0434509348",
    office_email: "info@website.com.au",
    agency_address: "123 Main Street, Anytown, Australia",
    /**
     * Datetime info field
     * We can add following dates for this setup here
     * Open home date
     * Auction date
     * Property availability date for sale or rent properties
     */
    // datetime_info: null,
    datetime_info: this.getNextWeekOpenHomeDate(),
    bond_price: "$2,500",

    fonts: this.commonFontsData,

    /**
     * Possible values
     *
     * for_rent or for_sale
     */
    listing_type: "for_sale",

    /**
     * Possible values
     *
     * For sale
     * coming_soon |  just_listed | auction | open_home | under_contract
     *
     * For rent
     * coming_soon | just_listed | open_home | deposit_taken
     */
    property_stage_type: "just_listed",

    /**
     * Transaction type values
     * For sale | For rent | Sale | Rent | Lease
     * etc
     */
    transaction_type_text: "For sale",
  };

  /**
   * Sample data for the auction post
   */
  static auction_property_marketing_for_sale = {
    template_url: {
      url: "https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/design-templates/01-general-purpose-template.svg",
      load: false,
    },
    output_image_file_path: {
      url: "E:/Projects/priyakant-makwana/design-work-repo/priyakant-makwana-design-work/output-images/24-06-2025/image-post-7cdf23c1-b194-11f0-aa94-7b7e22fd0c48-1761391175676.jpg",
      load: false,
    },
    output_image_relative_path: {
      url: "E:/Projects/priyakant-makwana/design-work-repo/priyakant-makwana-design-work/output-images/24-06-2025/image-post-7cdf23c1-b194-11f0-aa94-7b7e22fd0c48-1761391175676.jpg",
      load: false,
    },
    output_source_file_path: {
      url: "E:/Projects/priyakant-makwana/design-work-repo/priyakant-makwana-design-work/output-image-templates/24-06-2025/updated-template-7cdf23c2-b194-11f0-aa94-7b7e22fd0c48-1761391175676.ai",
      load: false,
    },
    property_stage: "Auction",
    property_address: "12 Chifley Drive, Preston, Victoria, 3072",
    agency_logo: {
      url: "https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/agency-logos/raywhite-original-logo.png",
      load: true,
    },
    design_main_image: {
      url: "https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/property-images/house-mage-compressed-06.jpg",
      load: true,
    },

    design_images: [
      {
        url: "https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/property-images/marvin-meyer-bfOQSDwEFg4-unsplash.jpg",
        load: true,
        index: 0,
        image_type: "property_image",
      },
      {
        url: "https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/property-images/1000X750-image.webp",
        load: true,
        index: 1,
        image_type: "property_image",
      },
    ],

    /**
     * Property price types
     * price-range
     * price-per-week
     * price-per-month
     * contact-agent
     * offer-above-xyz-price
     * content-agent-for-sell
     * price-guide-xyz-price
     * eoi
     */
    property_price_type: "price-guide-xyz-price",
    start_price: "$20,000",
    end_price: "$50,000",
    property_price: "$800",
    base_color_primary: { r: 255, g: 0, b: 0, hex: "#FFE512" },
    base_color_secondary: { r: 255, g: 255, b: 255, hex: "#595959" },
    text_color_primary: { r: 255, g: 255, b: 255, hex: "#595959" },
    text_color_secondary: { r: 255, g: 0, b: 0, hex: "#FFFFFF" },
    agent_name: "Ethan Cooper",
    agent_email: "new.agentemail@domain.com",
    agent_phone: "0400777888",
    agent_profile_image_path: {
      url: "https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/profile-images/compressed-demo-male-agent-profile-image.jpg",
      load: true,
    },
    // is_co_agent_available: false,
    co_agent_profile_image_path: {
      url: "https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/profile-images/compressed-demo-female-agent-profile-image.jpg",
      load: true,
    },

    /**
     * If co-agent not available
     */
    // co_agent_profile_image_path: null,

    co_agent_name: "Grace Harrison",
    co_agent_email: "new.coagentemail@domain.com",
    co_agent_phone: "0434509348",
    bathroom_count: 3,
    bedroom_count: 4,
    living_count: 2,
    parking_count: 1,
    property_area: "1020 m²",
    eoi_datetime: "26.09.2025, 06:00 PM",
    post_type: "image_post",
    design_template_id: "68fcaf8010a67d04555eb0da",
    agency_trading_name: "Greenview Real Estate",
    agency_website: "website.com.au",
    office_contact: "0434509348",
    office_email: "info@website.com.au",
    agency_address: "123 Main Street, Anytown, Australia",
    /**
     * Datetime info field
     * We can add following dates for this setup here
     * Open home date
     * Auction date
     * Property availability date for sale or rent properties
     */
    // datetime_info: null,
    datetime_info: this.getNextWeekAuctionDate(),
    bond_price: "$2,500",

    fonts: this.commonFontsData,

    /**
     * Possible values
     *
     * for_rent or for_sale
     */
    listing_type: "for_sale",

    /**
     * Possible values
     *
     * For sale
     * coming_soon |  just_listed | auction | open_home | under_contract
     *
     * For rent
     * coming_soon | just_listed | open_home | deposit_taken
     */
    property_stage_type: "auction",

    /**
     * Transaction type values
     * For sale | For rent | Sale | Rent | Lease
     * etc
     */
    transaction_type_text: "for sale",
  };

  /**
   * Sample data for the coming soon for rent post
   */
  static coming_soon_property_marketing_for_rent = {
    template_url: {
      url: "https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/design-templates/01-general-purpose-template.svg",
      load: false,
    },
    output_image_file_path: {
      url: "E:/Projects/priyakant-makwana/design-work-repo/priyakant-makwana-design-work/output-images/24-06-2025/image-post-7cdf23c1-b194-11f0-aa94-7b7e22fd0c48-1761391175676.jpg",
      load: false,
    },
    output_image_relative_path: {
      url: "E:/Projects/priyakant-makwana/design-work-repo/priyakant-makwana-design-work/output-images/24-06-2025/image-post-7cdf23c1-b194-11f0-aa94-7b7e22fd0c48-1761391175676.jpg",
      load: false,
    },
    output_source_file_path: {
      url: "E:/Projects/priyakant-makwana/design-work-repo/priyakant-makwana-design-work/output-image-templates/24-06-2025/updated-template-7cdf23c2-b194-11f0-aa94-7b7e22fd0c48-1761391175676.ai",
      load: false,
    },
    property_stage: "Coming Soon",
    property_address: "12 Chifley Drive, Preston, Victoria, 3072",
    agency_logo: {
      url: "https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/agency-logos/raywhite-original-logo.png",
      load: true,
    },
    design_main_image: {
      url: "https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/property-images/house-mage-compressed-06.jpg",
      load: true,
    },

    design_images: [
      {
        url: "https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/property-images/marvin-meyer-bfOQSDwEFg4-unsplash.jpg",
        load: true,
        index: 0,
        image_type: "property_image",
      },
      {
        url: "https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/property-images/1000X750-image.webp",
        load: true,
        index: 1,
        image_type: "property_image",
      },
    ],

    /**
     * Property price types
     * price-range
     * price-per-week
     * price-per-month
     * contact-agent
     * offer-above-xyz-price
     * content-agent-for-sell
     * price-guide-xyz-price
     * eoi
     */
    property_price_type: "price-per-week",
    start_price: "$20,000",
    end_price: "$50,000",
    property_price: "$800",
    base_color_primary: { r: 255, g: 0, b: 0, hex: "#FFE512" },
    base_color_secondary: { r: 255, g: 255, b: 255, hex: "#595959" },
    text_color_primary: { r: 255, g: 255, b: 255, hex: "#595959" },
    text_color_secondary: { r: 255, g: 0, b: 0, hex: "#FFFFFF" },
    agent_name: "Ethan Cooper",
    agent_email: "new.agentemail@domain.com",
    agent_phone: "0400777888",
    agent_profile_image_path: {
      url: "https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/profile-images/compressed-demo-male-agent-profile-image.jpg",
      load: true,
    },
    // is_co_agent_available: false,
    co_agent_profile_image_path: {
      url: "https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/profile-images/compressed-demo-female-agent-profile-image.jpg",
      load: true,
    },

    /**
     * If co-agent not available
     */
    // co_agent_profile_image_path: null,

    co_agent_name: "Grace Harrison",
    co_agent_email: "new.coagentemail@domain.com",
    co_agent_phone: "0434509348",
    bathroom_count: 3,
    bedroom_count: 4,
    living_count: 2,
    parking_count: 1,
    property_area: "1020 m²",
    eoi_datetime: "26.09.2025, 06:00 PM",
    post_type: "image_post",
    design_template_id: "68fcaf8010a67d04555eb0da",
    agency_trading_name: "Greenview Real Estate",
    agency_website: "website.com.au",
    office_contact: "0434509348",
    office_email: "info@website.com.au",
    agency_address: "123 Main Street, Anytown, Australia",
    /**
     * Datetime info field
     * We can add following dates for this setup here
     * Open home date
     * Auction date
     * Property availability date for sale or rent properties
     */
    // datetime_info: null,
    datetime_info: this.getNextWeekOpenHomeDate(),
    bond_price: "$2,500",

    fonts: this.commonFontsData,

    /**
     * Possible values
     *
     * for_rent or for_sale
     */
    listing_type: "for_rent",

    /**
     * Possible values
     *
     * For sale
     * coming_soon |  just_listed | auction | open_home | under_contract
     *
     * For rent
     * coming_soon | just_listed | open_home | deposit_taken
     */
    property_stage_type: "coming_soon",

    /**
     * Transaction type values
     * For sale | For rent | Sale | Rent | Lease
     * etc
     */
    transaction_type_text: "For rent",
  };

  /**
   * Sample data for the for rent post
   */
  static for_rent_listing_property_marketing_for_rent = {
    template_url: {
      url: "https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/design-templates/01-general-purpose-template.svg",
      load: false,
    },
    output_image_file_path: {
      url: "E:/Projects/priyakant-makwana/design-work-repo/priyakant-makwana-design-work/output-images/24-06-2025/image-post-7cdf23c1-b194-11f0-aa94-7b7e22fd0c48-1761391175676.jpg",
      load: false,
    },
    output_image_relative_path: {
      url: "E:/Projects/priyakant-makwana/design-work-repo/priyakant-makwana-design-work/output-images/24-06-2025/image-post-7cdf23c1-b194-11f0-aa94-7b7e22fd0c48-1761391175676.jpg",
      load: false,
    },
    output_source_file_path: {
      url: "E:/Projects/priyakant-makwana/design-work-repo/priyakant-makwana-design-work/output-image-templates/24-06-2025/updated-template-7cdf23c2-b194-11f0-aa94-7b7e22fd0c48-1761391175676.ai",
      load: false,
    },
    property_stage: "Just Listed",
    property_address: "12 Chifley Drive, Preston, Victoria, 3072",
    agency_logo: {
      url: "https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/agency-logos/raywhite-original-logo.png",
      load: true,
    },
    design_main_image: {
      url: "https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/property-images/house-mage-compressed-06.jpg",
      load: true,
    },

    design_images: [
      {
        url: "https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/property-images/marvin-meyer-bfOQSDwEFg4-unsplash.jpg",
        load: true,
        index: 0,
        image_type: "property_image",
      },
      {
        url: "https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/property-images/1000X750-image.webp",
        load: true,
        index: 1,
        image_type: "property_image",
      },
    ],

    /**
     * Property price types
     * price-range
     * price-per-week
     * price-per-month
     * contact-agent
     * offer-above-xyz-price
     * content-agent-for-sell
     * price-guide-xyz-price
     * eoi
     */
    property_price_type: "price-per-week",
    start_price: "$20,000",
    end_price: "$50,000",
    property_price: "$800",
    base_color_primary: { r: 255, g: 0, b: 0, hex: "#FFE512" },
    base_color_secondary: { r: 255, g: 255, b: 255, hex: "#595959" },
    text_color_primary: { r: 255, g: 255, b: 255, hex: "#595959" },
    text_color_secondary: { r: 255, g: 0, b: 0, hex: "#FFFFFF" },
    agent_name: "Ethan Cooper",
    agent_email: "new.agentemail@domain.com",
    agent_phone: "0400777888",
    agent_profile_image_path: {
      url: "https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/profile-images/compressed-demo-male-agent-profile-image.jpg",
      load: true,
    },
    // is_co_agent_available: false,
    co_agent_profile_image_path: {
      url: "https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/profile-images/compressed-demo-female-agent-profile-image.jpg",
      load: true,
    },

    /**
     * If co-agent not available
     */
    // co_agent_profile_image_path: null,

    co_agent_name: "Grace Harrison",
    co_agent_email: "new.coagentemail@domain.com",
    co_agent_phone: "0434509348",
    bathroom_count: 3,
    bedroom_count: 4,
    living_count: 2,
    parking_count: 1,
    property_area: "1020 m²",
    eoi_datetime: "26.09.2025, 06:00 PM",
    post_type: "image_post",
    design_template_id: "68fcaf8010a67d04555eb0da",
    agency_trading_name: "Greenview Real Estate",
    agency_website: "website.com.au",
    office_contact: "0434509348",
    office_email: "info@website.com.au",
    agency_address: "123 Main Street, Anytown, Australia",
    /**
     * Datetime info field
     * We can add following dates for this setup here
     * Open home date
     * Auction date
     * Property availability date for sale or rent properties
     */
    // datetime_info: null,
    datetime_info: this.getNextWeekOpenHomeDate(),
    bond_price: "$2,500",

    fonts: this.commonFontsData,

    /**
     * Possible values
     *
     * for_rent or for_sale
     */
    listing_type: "for_rent",

    /**
     * Possible values
     *
     * For sale
     * coming_soon |  just_listed | auction | open_home | under_contract
     *
     * For rent
     * coming_soon | just_listed | open_home | deposit_taken
     */
    property_stage_type: "just_listed",

    /**
     * Transaction type values
     * For sale | For rent | Sale | Rent | Lease
     * etc
     */
    transaction_type_text: "For rent",
  };

  /**
   * Sample data for the open home for rent post
   */
  static open_home_property_marketing_for_rent = {
    template_url: {
      url: "https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/design-templates/01-general-purpose-template.svg",
      load: false,
    },
    output_image_file_path: {
      url: "E:/Projects/priyakant-makwana/design-work-repo/priyakant-makwana-design-work/output-images/24-06-2025/image-post-7cdf23c1-b194-11f0-aa94-7b7e22fd0c48-1761391175676.jpg",
      load: false,
    },
    output_image_relative_path: {
      url: "E:/Projects/priyakant-makwana/design-work-repo/priyakant-makwana-design-work/output-images/24-06-2025/image-post-7cdf23c1-b194-11f0-aa94-7b7e22fd0c48-1761391175676.jpg",
      load: false,
    },
    output_source_file_path: {
      url: "E:/Projects/priyakant-makwana/design-work-repo/priyakant-makwana-design-work/output-image-templates/24-06-2025/updated-template-7cdf23c2-b194-11f0-aa94-7b7e22fd0c48-1761391175676.ai",
      load: false,
    },
    property_stage: "Open Home",
    property_address: "12 Chifley Drive, Preston, Victoria, 3072",
    agency_logo: {
      url: "https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/agency-logos/raywhite-original-logo.png",
      load: true,
    },
    design_main_image: {
      url: "https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/property-images/house-mage-compressed-06.jpg",
      load: true,
    },

    design_images: [
      {
        url: "https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/property-images/marvin-meyer-bfOQSDwEFg4-unsplash.jpg",
        load: true,
        index: 0,
        image_type: "property_image",
      },
      {
        url: "https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/property-images/1000X750-image.webp",
        load: true,
        index: 1,
        image_type: "property_image",
      },
    ],

    /**
     * Property price types
     * price-range
     * price-per-week
     * price-per-month
     * contact-agent
     * offer-above-xyz-price
     * content-agent-for-sell
     * price-guide-xyz-price
     * eoi
     */
    property_price_type: "price-per-month",
    start_price: "$20,000",
    end_price: "$50,000",
    property_price: "$800",
    base_color_primary: { r: 255, g: 0, b: 0, hex: "#FFE512" },
    base_color_secondary: { r: 255, g: 255, b: 255, hex: "#595959" },
    text_color_primary: { r: 255, g: 255, b: 255, hex: "#595959" },
    text_color_secondary: { r: 255, g: 0, b: 0, hex: "#FFFFFF" },
    agent_name: "Ethan Cooper",
    agent_email: "new.agentemail@domain.com",
    agent_phone: "0400777888",
    agent_profile_image_path: {
      url: "https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/profile-images/compressed-demo-male-agent-profile-image.jpg",
      load: true,
    },
    // is_co_agent_available: false,
    co_agent_profile_image_path: {
      url: "https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/profile-images/compressed-demo-female-agent-profile-image.jpg",
      load: true,
    },

    /**
     * If co-agent not available
     */
    // co_agent_profile_image_path: null,

    co_agent_name: "Grace Harrison",
    co_agent_email: "new.coagentemail@domain.com",
    co_agent_phone: "0434509348",
    bathroom_count: 3,
    bedroom_count: 4,
    living_count: 2,
    parking_count: 1,
    property_area: "1020 m²",
    eoi_datetime: "26.09.2025, 06:00 PM",
    post_type: "image_post",
    design_template_id: "68fcaf8010a67d04555eb0da",
    agency_trading_name: "Greenview Real Estate",
    agency_website: "website.com.au",
    office_contact: "0434509348",
    office_email: "info@website.com.au",
    agency_address: "123 Main Street, Anytown, Australia",
    /**
     * Datetime info field
     * We can add following dates for this setup here
     * Open home date
     * Auction date
     * Property availability date for sale or rent properties
     */
    // datetime_info: null,
    datetime_info: this.getNextWeekOpenHomeDate(),
    bond_price: "$2,500",

    fonts: this.commonFontsData,

    /**
     * Possible values
     *
     * for_rent or for_sale
     */
    listing_type: "for_rent",

    /**
     * Possible values
     *
     * For sale
     * coming_soon |  just_listed | auction | open_home | under_contract
     *
     * For rent
     * coming_soon | just_listed | open_home | deposit_taken
     */
    property_stage_type: "open_home",

    /**
     * Transaction type values
     * For sale | For rent | Sale | Rent | Lease
     * etc
     */
    transaction_type_text: "for rent",
  };

  /**
   * Sample data for the deposit taken post
   */
  static deposit_taken_property_marketing_for_rent = {
    template_url: {
      url: "https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/design-templates/01-general-purpose-template.svg",
      load: false,
    },
    output_image_file_path: {
      url: "E:/Projects/priyakant-makwana/design-work-repo/priyakant-makwana-design-work/output-images/24-06-2025/image-post-7cdf23c1-b194-11f0-aa94-7b7e22fd0c48-1761391175676.jpg",
      load: false,
    },
    output_image_relative_path: {
      url: "E:/Projects/priyakant-makwana/design-work-repo/priyakant-makwana-design-work/output-images/24-06-2025/image-post-7cdf23c1-b194-11f0-aa94-7b7e22fd0c48-1761391175676.jpg",
      load: false,
    },
    output_source_file_path: {
      url: "E:/Projects/priyakant-makwana/design-work-repo/priyakant-makwana-design-work/output-image-templates/24-06-2025/updated-template-7cdf23c2-b194-11f0-aa94-7b7e22fd0c48-1761391175676.ai",
      load: false,
    },
    property_stage: "Deposit Taken",
    property_address: "12 Chifley Drive, Preston, Victoria, 3072",
    agency_logo: {
      url: "https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/agency-logos/raywhite-original-logo.png",
      load: true,
    },
    design_main_image: {
      url: "https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/property-images/house-mage-compressed-06.jpg",
      load: true,
    },

    design_images: [
      {
        url: "https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/property-images/marvin-meyer-bfOQSDwEFg4-unsplash.jpg",
        load: true,
        index: 0,
        image_type: "property_image",
      },
      {
        url: "https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/property-images/1000X750-image.webp",
        load: true,
        index: 1,
        image_type: "property_image",
      },
    ],

    /**
     * Property price types
     * price-range
     * price-per-week
     * price-per-month
     * contact-agent
     * offer-above-xyz-price
     * content-agent-for-sell
     * price-guide-xyz-price
     * eoi
     */
    property_price_type: "price-per-month",
    start_price: "$20,000",
    end_price: "$50,000",
    property_price: "$800",
    base_color_primary: { r: 255, g: 0, b: 0, hex: "#FFE512" },
    base_color_secondary: { r: 255, g: 255, b: 255, hex: "#595959" },
    text_color_primary: { r: 255, g: 255, b: 255, hex: "#595959" },
    text_color_secondary: { r: 255, g: 0, b: 0, hex: "#FFFFFF" },
    agent_name: "Ethan Cooper",
    agent_email: "new.agentemail@domain.com",
    agent_phone: "0400777888",
    agent_profile_image_path: {
      url: "https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/profile-images/compressed-demo-male-agent-profile-image.jpg",
      load: true,
    },
    // is_co_agent_available: false,
    co_agent_profile_image_path: {
      url: "https://pub-0b7e31f75477417ca5d2b3de90ef25c1.r2.dev/testing-assets/profile-images/compressed-demo-female-agent-profile-image.jpg",
      load: true,
    },

    /**
     * If co-agent not available
     */
    // co_agent_profile_image_path: null,

    co_agent_name: "Grace Harrison",
    co_agent_email: "new.coagentemail@domain.com",
    co_agent_phone: "0434509348",
    bathroom_count: 3,
    bedroom_count: 4,
    living_count: 2,
    parking_count: 1,
    property_area: "1020 m²",
    eoi_datetime: "26.09.2025, 06:00 PM",
    post_type: "image_post",
    design_template_id: "68fcaf8010a67d04555eb0da",
    agency_trading_name: "Greenview Real Estate",
    agency_website: "website.com.au",
    office_contact: "0434509348",
    office_email: "info@website.com.au",
    agency_address: "123 Main Street, Anytown, Australia",
    /**
     * Datetime info field
     * We can add following dates for this setup here
     * Open home date
     * Auction date
     * Property availability date for sale or rent properties
     */
    // datetime_info: null,
    datetime_info: this.getNextWeekOpenHomeDate(),
    bond_price: "$2,500",

    fonts: this.commonFontsData,

    /**
     * Possible values
     *
     * for_rent or for_sale
     */
    listing_type: "for_rent",

    /**
     * Possible values
     *
     * For sale
     * coming_soon |  just_listed | auction | open_home | under_contract
     *
     * For rent
     * coming_soon | just_listed | open_home | deposit_taken
     */
    property_stage_type: "deposit_taken",

    /**
     * Transaction type values
     * For sale | For rent | Sale | Rent | Lease
     * etc
     */
    transaction_type_text: "for rent",
  };
}

export default PropertyStagesDesignData;
